import React from 'react';
import type {
  Experience,
  ExperienceTaxonomy,
  Taxonomy,
} from '@axiom/validation';

import { CondensedHeader } from '../../content/CondensedHeader/CondensedHeader';
import { CondensedLarge } from '../../content/CondensedLarge/CondensedLarge';
import { Layout } from '../../layout/Layout/Layout';
import { LayoutItem } from '../../layout/Layout/LayoutItem';
import { CandidateTaxonomyUtil } from '../../../utils/candidate-taxonomy-util';

export type ExperienceTaxonomyLegalSkillsDisplayProps = {
  experienceTaxonomy: ExperienceTaxonomy[];
  experiencesFocusAreaOrderPreferences?: Experience['experiencesFocusAreaOrderPreferences'];
  name?: string;
  taxonomy: Taxonomy;
};

export const ExperienceTaxonomyLegalSkillsDisplay = ({
  experienceTaxonomy,
  experiencesFocusAreaOrderPreferences,
  name = 'EXPERIENCE_TAXONOMY_LEGAL_SKILLS_DISPLAY',
  taxonomy,
}: ExperienceTaxonomyLegalSkillsDisplayProps) => {
  const formattedExperienceTaxonomy =
    CandidateTaxonomyUtil.groupExperienceTaxonomyByFocusArea(
      experienceTaxonomy,
      experiencesFocusAreaOrderPreferences
    );

  if (Object.keys(formattedExperienceTaxonomy).length === 0) {
    return null;
  }

  return (
    <Layout name={name} direction="vertical" verticalGutter="16px">
      {formattedExperienceTaxonomy
        .filter(fa => (fa?.skillGroups.length ?? 0) > 0)
        .map(fa => (
          <LayoutItem key={fa?.focusArea} name="FOCUS_AREA_GROUP">
            {fa?.focusArea ? (
              <CondensedHeader name="FOCUS_AREA">
                {taxonomy.focusAreas[fa.focusArea]?.fullName}
              </CondensedHeader>
            ) : null}
            {fa?.skillGroups.map(sg => (
              <CondensedLarge key={sg.skillGroup}>
                <span data-test="SKILL_GROUP">
                  {taxonomy.skillGroups[sg.skillGroup]?.fullName}:{' '}
                </span>
                <span data-test="LEGAL_SKILLS">
                  {sg.legalSkills
                    .map(ls => taxonomy.legalSkills[ls]?.fullName)
                    .join('; ')}
                </span>
              </CondensedLarge>
            ))}
          </LayoutItem>
        ))}
    </Layout>
  );
};
